import React, { useEffect } from 'react'
import Navbar from './Navbar'
import { FaBuilding } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import "./RegistrationChoice.css"
import { Link } from 'react-router-dom';

const RegistrationChoice = () => {
    useEffect(() => {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      scrollToTop()
    }, [])

    const handleUserRegisterChoiceButtonClick = () => {
      window.gtag('event', 'click', {
        event_category: 'Button',
        event_action: 'Click',
        event_label: 'Vyber registrace uzivatele',
      });
    };
    const handleBusinessRegisterChoiceButtonClick = () => {
      window.gtag('event', 'click', {
        event_category: 'Button',
        event_action: 'Click',
        event_label: 'Vyber registrace podniku',
      });
    };
  return (
    <div>
        <Navbar />
        <div className='registration-container'>
        <div className='registration-choice-container'>
        <Link to="/register" onClick={handleUserRegisterChoiceButtonClick}>
            <FaUser className='registration-icon' />
            <div className='title-container'>
              <h2 className='registration-choice-title'>Uživatelská registrace</h2>
            </div>
            </Link>
          </div>
          <div className='registration-choice-container'>
          <Link to="/business/register" onClick={handleBusinessRegisterChoiceButtonClick}>
            <FaBuilding className='registration-icon'/>
            <div className='title-container'>
              <h2 className='registration-choice-title'>Firemní registrace</h2>
            </div>
            </Link>
          </div>
        </div>
        </div>

  )
}

export default RegistrationChoice